import { styled } from 'styled-components'

import { getAppUrl } from '../../../config/config'
import { notifyUserToSignAgreement, User } from '../../../models/user'
import { useUserProvider } from '../../Context/UserContext'
import { DropdownButton } from '../../Dropdown/DropdownButton'
import { EMPLOYMENT_ROUTES } from '../EmploymentHistory/EmploymentHistory.constants'

interface TasklistShareDropdownProps {
  user: User
}

export function TasklistShareDropdown({ user }: TasklistShareDropdownProps) {
  const { showBanner } = useUserProvider()

  const options = [
    {
      label: 'Send email & text',
      onClick: async () => {
        await notifyUserToSignAgreement(user.id, true)
        showBanner('success', { message: 'Email and SMS sent' })
      },
    },
    {
      label: 'Copy link',
      onClick: () => {
        navigator.clipboard.writeText(`${getAppUrl()}${EMPLOYMENT_ROUTES.ONBOARDING_EMPLOYMENT_SUBMIT}`)
        showBanner('success', { message: 'Link copied!' })
      },
    },
  ]

  return (
    <Wrap>
      <DropdownButton
        options={options}
        label="Send user agreements"
        buttonProps={{ variant: 'text' }}
        width={250}
        align="right"
        fontSize="12px"
      />
    </Wrap>
  )
}

const Wrap = styled.div`
  padding-right: 10px;
  width: 200px;
  display: flex;
  justify-content: start;
`
